.main-container {
  width: max-content;
  animation: scroll var(--scroll-duration) linear infinite;
  display: flex;

  &:hover {
    animation-play-state: paused;
  }
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-50%));
  }
}

.dynamic-table {
  display: flex;
  gap: 1rem;
  padding: 1rem 0.5rem;
  width: max-content;
}

.dynamic-table__row,
.dynamic-table__iconrow {
  display: grid;
  padding: 10px 15px;
  border-radius: 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  justify-content: center;
  font-family: 'Matter SQ';
  width: 250px;
  height: 55px;
}

.dynamic-table__iconrow {
  column-gap: 10px;
  grid-template-columns: 0.1fr 0.9fr;
}

.dynamic-table__icon {
  display: flex;
  border-radius: 32px;
  justify-content: center;
  align-items: center;
  align-self: center;

  img {
    width: 45px;
    height: 45px;
  }
}

.dynamic-table__epicsData {
  display: grid;
  column-gap: 10px;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  font-size: 16px;
}

.dynamic-table__epicName {
  display: flex;
  align-items: center;
}

.dynamic-table__fids {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 70px;
  justify-content: center;
}

.dynamic-table__epicsData .dynamic-table__fids .dynamic-table__cell {
  align-self: flex-end;
}

[data-field$='CPC']:after {
  content: '%';
}

.pricing-info {
  display: flex;
  flex-direction: column;
}

span[data-field='V2-F-BID'],
span[data-field='OFR'] {
  display: none;
}

span[data-field='CPC'] {
  margin-top: 7px;
}

.market-epic-link {
  color: @black;
  text-decoration: none;
  font-weight: 600;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 110px;
}

.market-info {
  display: flex;
  flex-direction: column;
}

.price--up-cpc {
  color: var(--value--positive, #065bdb);
  height: 14px;
}

.price--down-cpc {
  color: var(--value--negative, #ff514b);
  height: 14px;
}

.price--up-cpc::before {
  content: '+';
}

.price--up,
.price--down {
  display: inline-block;
  position: relative;
  background-repeat: no-repeat;
  background-position: right 4px;
  background-size: 7px;
}

.price--up {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDYgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjM0ODA2IDIuNTEyMDhMMCAzLjAyNTk1TDIuNzYwMTUgMEw1LjUzODQ2IDMuMDEzMjVMMy4xNzIyNCAyLjUwODE1VjkuNjkyMzFIMi4zNDgwNlYyLjUxMjA4WiIgZmlsbD0iIzA2NUJEQiIvPgo8L3N2Zz4K);
}

.price--down {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDYgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjM0ODA2IDcuMTgwMjVMMCA2LjY2NjM3TDIuNzYwMTUgOS42OTIzMUw1LjUzODQ2IDYuNjc5MDZMMy4xNzIyNCA3LjE4NDE3VjBIMi4zNDgwNlY3LjE4MDI1WiIgZmlsbD0iI0U2MUUxRSIvPgo8L3N2Zz4K);
}

span[data-field='OFR'],
span[data-field='V2-F-BID'] {
  display: none !important;
}

span[data-field='MID'],
span[data-field='CPC'] {
  padding-right: 10px;
}

.dynamic-table__row:hover,
.dynamic-table__iconrow:hover {
  transform: scale(1.05);
}

.un:hover {
  cursor: default;
}

.clickable--desktop {
  pointer-events: none;
  cursor: default;
}
